// NewsSection.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const NewsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {/* Left Side */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block bg-[#F5F8FA] text-[#2542D4] text-xs font-light px-6 py-2 rounded-full mb-4">
              From the Blog
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356]">
              News & Updates
            </h2>
          </motion.div>
          
          {/* Right Side */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex flex-col justify-center"
          >
            <p className="text-gray-600 text-sm font-light leading-relaxed mb-4">
              Stay informed with practical insights, updates, and guidance on studying and working abroad. Our articles cover global education trends, international job markets, application preparation tips, and important considerations to help you make informed decisions.
            </p>
            <p className="text-gray-600 text-sm font-light leading-relaxed mb-6">
              We focus on clarity and preparation, breaking down complex topics into practical and easy to understand guidance for individuals exploring international opportunities.
            </p>
            <Link 
              to="/blog" 
              className="text-[#202356] text-sm font-normal border-b border-[#202356] pb-1 hover:opacity-80 transition inline-block w-fit"
            >
              View latest updates
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
